import { render, staticRenderFns } from "./TraitsList.vue?vue&type=template&id=5274d2a5"
import script from "./TraitsList.vue?vue&type=script&lang=js"
export * from "./TraitsList.vue?vue&type=script&lang=js"
import style0 from "./TraitsList.vue?vue&type=style&index=0&id=5274d2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports